import AddExpenses from '../../pages/Transactions/AddExpenses';
import { TransactionsController } from '../../controllers';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { string, object, number } from 'yup';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddExpensesContainer = ({ closeModal, type, setShowSurvey }) => {
	const [openExpenseModal, setOpenExpenseModal] = useState(true);
	const [expenseSuccess, setExpenseSuccess] = useState(false);
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(type === "OUTFLOW" ? constant.FEEDBACK.TRANSACTIONSADDEXPENSE
		: type === 'DEBT' ? constant.FEEDBACK.TRANSACTIONSADDDEBT : "");

	const getAddedExpenses = () => {
		setOpenExpenseModal(false);
		setExpenseSuccess(true);
	};

	const addNewExpense = () => {
		setOpenExpenseModal(true);
		setExpenseSuccess(false);
	};
	const onCloseModal = () => {
		closeModal();
		setLoading(false);
	}
	const validationSchema = () => {
		return object({
			expenseCategory: string().required('Expense Category is required'),
			transactionAmount: number()
				.required('Amount charged is required')
				.min(1, 'The minimum transaction amount should be 1'),
			currencyCode: string().required('Select Currency'),
			deposit: number().test(function () {
				const { deposit } = this.parent;
				return type === 'OUTFLOW' && deposit === 0
					? this.createError({
						message: 'Amount Paid is required required',
						path: 'deposit',
					})
					: true;
			}),
			narration: string().required('Narration is required'),
			balanceDueDate: string().test(function () {
				const { transactionAmount, deposit, balanceDueDate } = this.parent;
				return type === 'OUTFLOW' && transactionAmount - deposit > 0 && !balanceDueDate
					? this.createError({
						message: 'Expected balance payment date is required',
						path: 'balanceDueDate',
					})
					: true;
			}),
			paidDate: string().test(function () {
				const { paidDate } = this.parent;
				return type === 'OUTFLOW' && !paidDate
					? this.createError({
						message: 'Paid date is required',
						path: 'paidDate',
					})
					: true;
			}),
			paymentMethod: string().test(function () {
				const { paymentMethod } = this.parent;
				return type === 'OUTFLOW' && !paymentMethod
					? this.createError({
						message: 'Payment Method is required',
						path: 'paymentMethod',
					})
					: true;
			}),
			dueDate: string().test(function () {
				const { dueDate } = this.parent;
				return type !== 'OUTFLOW' && !dueDate
					? this.createError({
						message: 'Due Date is required',
						path: 'dueDate',
					})
					: true;
			}),
		});
	};

	const onSubmit = async values => {
		let payload = {};

		setLoading(true);
		for (const key in values) {
			if (values[key] === '') {
				delete values[key];
			}
		}
		payload = {
			...values,
		};
		if (!values.balanceDueDate && type === 'OUTFLOW') {
			delete values.balanceDueDate;
			payload.paidDate = values.paidDate.toDateString();
		}
		if (values.balanceDueDate && type === 'OUTFLOW') {
			payload.paidDate = values.paidDate.toDateString();
			payload.balanceDueDate = values.balanceDueDate.toDateString();
		}
		payload.type = type;

		const { status, errorMessage } = await TransactionsController.postExpense(
			payload
		);
		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return getAddedExpenses();
		}
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddExpenses
			closeModal={onCloseModal}
			type={type}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			loading={loading}
			openExpenseModal={openExpenseModal}
			expenseSuccess={expenseSuccess}
			addNewExpense={addNewExpense}
			setShowSurvey={setShowSurvey}
			needFeedback={needFeedback}
		/>
	);
};

export default observer(AddExpensesContainer);
